import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import NewsLayout from '../../components/feature/NewsLayout';

interface Article {
  id: string;
  title: string;
  content: string;
  category: string;
  excerpt: string;
  image_url: string;
  author: string;
  published_at: string;
  tags: string[];
  view_count: number;
}

export default function NewsPage() {
  const [searchParams] = useSearchParams();
  const category = searchParams.get('category') || '全部';
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchArticles();
  }, [category]);

  const fetchArticles = async () => {
    try {
      setLoading(true);
      const url = category === '全部' 
        ? `${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/get-articles`
        : `${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/get-articles?category=${encodeURIComponent(category)}`;
      
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY}`,
        },
      });
      
      if (response.ok) {
        const data = await response.json();
        setArticles(data.articles || []);
      }
    } catch (error) {
      console.error('獲取文章失敗:', error);
    } finally {
      setLoading(false);
    }
  };

  const getCategoryColor = (cat: string) => {
    switch (cat) {
      case '塔羅占卜': return 'bg-purple-600';
      case '八字算命': return 'bg-red-600';
      case '紫微斗數': return 'bg-blue-600';
      case '星座運勢': return 'bg-yellow-600';
      default: return 'bg-gray-600';
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <NewsLayout 
          articles={articles}
          loading={loading}
          category={category}
          categoryColor={getCategoryColor(category)}
        />
      </main>
      <Footer />
    </div>
  );
}